import { createIcon } from "@hopper-ui/icons";
import type { ComponentProps } from "react";

const O365TeamsChannel32 = (props: ComponentProps<"svg">) => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.8114 6.00095C22.1559 6.51794 22.0164 7.21639 21.4993 7.56106L14.7493 12.0611C14.2324 12.4057 13.5339 12.266 13.1892 11.749C12.8446 11.2321 12.9843 10.5336 13.5013 10.1889L20.2433 5.68894C20.7603 5.34429 21.4667 5.48399 21.8114 6.00095Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.1892 20.251C13.5339 19.734 14.2324 19.5943 14.7493 19.939L21.4993 24.439C22.0164 24.7836 22.1559 25.4821 21.8114 25.9991C21.4667 26.516 20.7603 26.6557 20.2433 26.3111L13.5013 21.8111C12.9843 21.4664 12.8446 20.7679 13.1892 20.251Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.5003 16C14.5003 15.3787 15.007 14.875 15.6283 14.875H20.8753C21.4966 14.875 22.0033 15.3787 22.0033 16C22.0033 16.6213 21.4966 17.125 20.8753 17.125H15.6283C15.007 17.125 14.5003 16.6213 14.5003 16Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.0003 12.625V19.375C16.0003 20.8247 14.8251 22 13.3753 22H6.62534C5.17523 22 4 20.8247 4 19.375V12.625C4 11.1753 5.17523 10 6.62534 10H13.3753C14.8251 10 16.0003 11.1753 16.0003 12.625ZM13.7503 19.375V12.625C13.7503 12.4199 13.5805 12.25 13.3753 12.25H6.62534C6.42019 12.25 6.25034 12.4199 6.25034 12.625V19.375C6.25034 19.5802 6.42019 19.75 6.62534 19.75H13.3753C13.5805 19.75 13.7503 19.5802 13.7503 19.375Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.5003 5.125C23.5003 4.50368 24.007 4 24.6283 4H26.8723C27.4936 4 28.0003 4.50368 28.0003 5.125V7.375C28.0003 7.99632 27.4936 8.5 26.8723 8.5H24.6283C24.007 8.5 23.5003 7.99632 23.5003 7.375V5.125Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.5003 24.625C23.5003 24.0037 24.007 23.5 24.6283 23.5H26.8723C27.4936 23.5 28.0003 24.0037 28.0003 24.625V26.875C28.0003 27.4963 27.4936 28 26.8723 28H24.6283C24.007 28 23.5003 27.4963 23.5003 26.875V24.625Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.5003 14.875C23.5003 14.2537 24.007 13.75 24.6283 13.75H26.8723C27.4936 13.75 28.0003 14.2537 28.0003 14.875V17.125C28.0003 17.7463 27.4936 18.25 26.8723 18.25H24.6283C24.007 18.25 23.5003 17.7463 23.5003 17.125V14.875Z"
                fill="currentColor"
            />
        </svg>
    );
};

const O365TeamsChannel24 = (props: ComponentProps<"svg">) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.3585 4.50071C16.6169 4.88846 16.5123 5.41229 16.1245 5.6708L11.062 9.0458C10.6743 9.30428 10.1504 9.19951 9.89194 8.81178C9.63343 8.42406 9.73822 7.90019 10.126 7.6417L15.1825 4.26671C15.5702 4.00822 16.1 4.11299 16.3585 4.50071Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.89193 15.1882C10.1504 14.8005 10.6743 14.6957 11.062 14.9542L16.1245 18.3292C16.5123 18.5877 16.6169 19.1116 16.3585 19.4993C16.1 19.887 15.5702 19.9918 15.1825 19.7333L10.126 16.3583C9.73822 16.0998 9.63343 15.5759 9.89193 15.1882Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.8752 12C10.8752 11.534 11.2553 11.1562 11.7212 11.1562H15.6565C16.1225 11.1562 16.5025 11.534 16.5025 12C16.5025 12.466 16.1225 12.8438 15.6565 12.8438H11.7212C11.2553 12.8438 10.8752 12.466 10.8752 12Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.0002 9.46875V14.5312C12.0002 15.6185 11.1188 16.5 10.0315 16.5H4.969C3.88142 16.5 3 15.6185 3 14.5312V9.46875C3 8.38144 3.88142 7.5 4.969 7.5H10.0315C11.1188 7.5 12.0002 8.38144 12.0002 9.46875ZM10.3127 14.5312V9.46875C10.3127 9.31489 10.1854 9.1875 10.0315 9.1875H4.969C4.81514 9.1875 4.68775 9.31489 4.68775 9.46875V14.5312C4.68775 14.6852 4.81514 14.8125 4.969 14.8125H10.0315C10.1854 14.8125 10.3127 14.6852 10.3127 14.5312Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.6252 3.84375C17.6252 3.37776 18.0053 3 18.4712 3H20.1542C20.6202 3 21.0002 3.37776 21.0002 3.84375V5.53125C21.0002 5.99724 20.6202 6.375 20.1542 6.375H18.4712C18.0053 6.375 17.6252 5.99724 17.6252 5.53125V3.84375Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.6252 18.4688C17.6252 18.0028 18.0053 17.625 18.4712 17.625H20.1542C20.6202 17.625 21.0002 18.0028 21.0002 18.4688V20.1562C21.0002 20.6222 20.6202 21 20.1542 21H18.4712C18.0053 21 17.6252 20.6222 17.6252 20.1562V18.4688Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.6252 11.1562C17.6252 10.6903 18.0053 10.3125 18.4712 10.3125H20.1542C20.6202 10.3125 21.0002 10.6903 21.0002 11.1562V12.8438C21.0002 13.3097 20.6202 13.6875 20.1542 13.6875H18.4712C18.0053 13.6875 17.6252 13.3097 17.6252 12.8438V11.1562Z"
                fill="currentColor"
            />
        </svg>
    );
};

const O365TeamsChannel16 = (props: ComponentProps<"svg">) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.9057 3.00048C11.078 3.25897 11.0082 3.6082 10.7497 3.78053L7.37465 6.03053C7.1162 6.20286 6.76695 6.13301 6.59463 5.87452C6.42229 5.61604 6.49215 5.2668 6.75065 5.09447L10.1217 2.84447C10.3802 2.67215 10.7334 2.742 10.9057 3.00048Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.59462 10.1255C6.76695 9.867 7.1162 9.79715 7.37465 9.9695L10.7497 12.2195C11.0082 12.3918 11.078 12.7411 10.9057 12.9996C10.7334 13.258 10.3802 13.3279 10.1217 13.1556L6.75065 10.9056C6.49215 10.7332 6.42229 10.384 6.59462 10.1255Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.25015 8C7.25015 7.68935 7.5035 7.4375 7.81415 7.4375H10.4377C10.7483 7.4375 11.0017 7.68935 11.0017 8C11.0017 8.31065 10.7483 8.5625 10.4377 8.5625H7.81415C7.5035 8.5625 7.25015 8.31065 7.25015 8Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.00015 6.3125V9.6875C8.00015 10.4123 7.41255 11 6.68765 11H3.31267C2.58762 11 2 10.4123 2 9.6875V6.3125C2 5.58763 2.58762 5 3.31267 5H6.68765C7.41255 5 8.00015 5.58763 8.00015 6.3125ZM6.87515 9.6875V6.3125C6.87515 6.20993 6.79025 6.125 6.68765 6.125H3.31267C3.21009 6.125 3.12517 6.20993 3.12517 6.3125V9.6875C3.12517 9.7901 3.21009 9.875 3.31267 9.875H6.68765C6.79025 9.875 6.87515 9.7901 6.87515 9.6875Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.7502 2.5625C11.7502 2.25184 12.0035 2 12.3142 2H13.4362C13.7468 2 14.0002 2.25184 14.0002 2.5625V3.6875C14.0002 3.99816 13.7468 4.25 13.4362 4.25H12.3142C12.0035 4.25 11.7502 3.99816 11.7502 3.6875V2.5625Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.7502 12.3125C11.7502 12.0019 12.0035 11.75 12.3142 11.75H13.4362C13.7468 11.75 14.0002 12.0019 14.0002 12.3125V13.4375C14.0002 13.7481 13.7468 14 13.4362 14H12.3142C12.0035 14 11.7502 13.7481 11.7502 13.4375V12.3125Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.7502 7.4375C11.7502 7.12685 12.0035 6.875 12.3142 6.875H13.4362C13.7468 6.875 14.0002 7.12685 14.0002 7.4375V8.5625C14.0002 8.87315 13.7468 9.125 13.4362 9.125H12.3142C12.0035 9.125 11.7502 8.87315 11.7502 8.5625V7.4375Z"
                fill="currentColor"
            />
        </svg>
    );
};

export const O365TeamsChannelIcon = createIcon(
    O365TeamsChannel16,
    O365TeamsChannel24,
    O365TeamsChannel32,
    "O365TeamsChannelIcon"
);
